export default __webpack_public_path__ + "static/media/evideo.0ebe00a1.mp4";